import React from "react";
import TextInput from "common/TextInput";
import SelectInput from "common/SelectInput";
import PasswordInput from "common/PasswordInput";
import FoldablePanel from "common/FoldablePanel";
import ArrangeInColumns from "common/layouts/ArrangeInColumns";
import SwitchInput from "common/SwitchInputWithState";
import NonBlockingStatus, {Grouped} from "./Common/NonBlockingStatus";
import Wrapper from "./Common/Wrapper";

const doesNothing = () => {};

const powercodeBillingSubscribers = [
  { label: "Leave unchanged", value: "unchanged" },
  { label: "Customer-ID", value: "customer-id" },
  { label: "Equipment-ID", value: "equipment-id" },
  { label: "MAC", value: "mac" },
  { label: "Name", value: "name" },
];

const defaultPowercodeBlockingStatus = [
  {
    __id: 1,
    fixed: true,
    name: "Active",
    stored: true,
  },
]

const PowerCodeBillingSettings = ({
  onChange,
  defaults = {},
  state,
  local = {},
  setLocal = doesNothing,
}) => (
  <>
    <TextInput
      type="text"
      label="User:"
      name="username"
      className="input-group"
      defaultValue={defaults.username}
      onChange={onChange}
    />
    <PasswordInput
      defaultValue={defaults.password}
      className="input-group"
      name="password"
      onChange={onChange}
    />
    <FoldablePanel
      title="MySQL Credentials"
      className="full-width padding-b-10"
      opened={local.mysqlFoldedPanelOpen === true}
      onChange={(mysqlFoldedPanelOpen) =>
        setLocal((previous) => ({ ...previous, mysqlFoldedPanelOpen }))
      }
    >
      <ArrangeInColumns rowGap="0.2em">
        <div className="full-width padding-b-10">
          <small>
            The <code>Username</code> and <code>Password</code> above will used
            if these fields are empty in order to access the MySQL database.
          </small>
        </div>
        <TextInput
          type="text"
          label="User:"
          name="mysqlUsername"
          className="input-group"
          defaultValue={defaults.mysqlUsername}
          onChange={onChange}
        />
        <PasswordInput
          defaultValue={defaults.mysqlPassword}
          className="input-group"
          name="mysqlPassword"
          onChange={onChange}
        />
      </ArrangeInColumns>
    </FoldablePanel>

    <TextInput
      type="text"
      label="Equipment Categories (leave empty for all):"
      name="equipmentCategories"
      className="input-control"
      defaultValue={defaults.equipmentCategories}
      onChange={onChange}
    />
    <SwitchInput
      name="powercodePolicyName"
      className={`input-group input-control`}
      defaultChecked={defaults.powercodePolicyName}
      onChange={onChange}
      label={"Policy names from Powercode"}
    />
    <Wrapper>
      <SelectInput
        label="Subscriber-ID source"
        name="subscriberIdSource"
        onChange={onChange}
        defaultValue={defaults.subscriberIdSource}
        options={powercodeBillingSubscribers}
      />
    </Wrapper>
    <Grouped className="margin-t-0">
      <NonBlockingStatus
        className="has-input-groups column-prefer-left"
        onChange={({ list }) =>
          onChange(null, { name: "powercodeNonBlockingStatus", value: list })
        }
        state={state}
        defaults={{ list: defaults.powercodeNonBlockingStatus || defaultPowercodeBlockingStatus }}
      />
    </Grouped>
  </>
);

export default PowerCodeBillingSettings;
